module.exports = __webpack_public_path__ + "img/waiter-place-order-mobile.290a9ef8.webp";